export const apiConstants = {
  GetAllCourseConfigs: 'services/app/CourseConfiguration/GetAll',
  GetCourseConfig: 'services/app/CourseConfiguration/Get',
};
